import { render, staticRenderFns } from "./LeadAgeingDetails.vue?vue&type=template&id=793df417&scoped=true&"
import script from "./LeadAgeingDetails.vue?vue&type=script&lang=js&"
export * from "./LeadAgeingDetails.vue?vue&type=script&lang=js&"
import style0 from "./LeadAgeingDetails.vue?vue&type=style&index=0&id=793df417&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793df417",
  null
  
)

export default component.exports